import { render } from "./controlling-file-size.md?vue&type=template&id=2d769c57"
const script = {}
script.render = render

export default script